import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import "react-table/react-table.css";
import { getParams } from "../actions/shared/actions_shared_1";
import store from './../store/index';
import AdminIndex from "./admin";
import Entreprise from "./entreprise/index";
import Salarie from "./salarie/index";
import Inscription from "./shared/pages/Inscription";
import LastPosts from './shared/pages/LastPosts';
import LoginPage from "./shared/pages/LoginPage";
import NoMatch from "./shared/pages/NoMatch";
import RecupMotDePasse from "./shared/pages/RecupMotDePasse";
import PrivateRoute from './shared/utils/PrivateRoute';


export default class MainRouter extends Component {

    constructor(props) {
        super(props);
        store.dispatch(getParams());
    }

    render() {
        return (
            <Switch>
                <Route exact path="/" component={LoginPage} />
                <Route exact path="/recup_mot_de_passe" component={RecupMotDePasse} />
                <Route exact path="/inscription" component={Inscription} />
                <Route exact path="/last-posts" component={LastPosts} />
                <PrivateRoute path="/entreprise" component={Entreprise} />
                <PrivateRoute path="/salarie" component={Salarie} />
                <PrivateRoute path="/admin" component={AdminIndex} />
                <Route component={NoMatch} />
            </Switch>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/MainRouter.js